export class Currency {
  id: number;
  shortcode: string;
  name: string;
  description: string;
  status: number;
  permissions: Array<string>;
}
